import component from './tr-TR/component';
import globalHeader from './tr-TR/globalHeader';
import menu from './tr-TR/menu';
import pages from './tr-TR/pages';
import pwa from './tr-TR/pwa';
import settings from './tr-TR/settings';
import themes from './tr-TR/themes';
import validation from './tr-TR/validation';

export default {
  'app.name': 'Yeditepe University',
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Yardım',
  'layout.user.link.privacy': 'Gizlilik',
  'layout.user.link.terms': 'Şartlar',
  'app.copyright.produced': 'Yeditepe Bilgi İşlem Koordinatörlüğü Tarafından Geliştirilmiştir.',
  ...globalHeader,
  ...menu,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...themes,
  ...validation,
};
